module.exports = __webpack_public_path__ + "img/04-2.0ee27f38.png";